import { MutationTree } from "vuex";
import { Mutations, MutationTypes } from "./MutationsType";
import { State } from "./contract";
// Define mutations
export const mutations: MutationTree<State> & Mutations = {};
